var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHalfStart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_570_3294)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3314 10.4542H23.3317L17.3791 14.9587L19.6722 22.2876C19.7081 22.402 19.7277 22.5234 19.7277 22.6504C19.7277 23.29 19.2318 23.8092 18.6197 23.8092C18.3771 23.8092 18.1529 23.7273 17.9706 23.5885L17.9703 23.5892L11.9721 19.0502L5.97358 23.5885C5.7912 23.7273 5.56712 23.8092 5.32443 23.8092C4.71242 23.8092 4.21647 23.29 4.21647 22.6504C4.21647 22.5234 4.23605 22.402 4.27194 22.2876L6.56515 14.9587L0.612748 10.4542C0.334792 10.2437 0.153961 9.90194 0.153961 9.51544C0.153961 8.87544 0.649977 8.35662 1.26192 8.35662H8.63062L10.9128 1.06289C11.0516 0.588419 11.4733 0.243896 11.9721 0.243896C12.4709 0.243896 12.8925 0.588396 13.0313 1.06289L15.3132 8.35662H22.6822C23.2942 8.35662 23.7901 8.87542 23.7901 9.51544C23.7901 9.90196 23.6093 10.2437 23.3314 10.4542Z",
    fill: "#BAC8D2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_570_3294",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3315 10.454H23.3318L17.3792 14.9584L19.6723 22.2874C19.7082 22.4017 19.7278 22.5231 19.7278 22.6502C19.7278 23.2898 19.2319 23.8089 18.6198 23.8089C18.3771 23.8089 18.153 23.727 17.9706 23.5883L17.9704 23.5889L11.9722 19.05L5.97367 23.5883C5.79129 23.727 5.56721 23.8089 5.32452 23.8089C4.71251 23.8089 4.21656 23.2898 4.21656 22.6502C4.21656 22.5231 4.23614 22.4017 4.27203 22.2874L6.56524 14.9584L0.612839 10.454C0.334884 10.2435 0.154053 9.9017 0.154053 9.51519C0.154053 8.8752 0.650068 8.35638 1.26201 8.35638H8.63071L10.9129 1.06265C11.0517 0.588175 11.4733 0.243652 11.9722 0.243652C12.471 0.243652 12.8926 0.588152 13.0314 1.06265L15.3133 8.35638H22.6823C23.2943 8.35638 23.7902 8.87518 23.7902 9.51519C23.7902 9.90172 23.6094 10.2435 23.3315 10.454Z",
    fill: "#BAC8D2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_570_3294)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 24,
    fill: "#FFD15A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_570_3294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfStart);
export default __webpack_public_path__ + "static/media/half_start.f93dc39b90b41f2c4fe3eba61d34c57d.svg";
export { ForwardRef as ReactComponent };